import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import GoEasy from 'goeasy'
import { fetchPost, fetchGet } from '@/utils/request'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.config.productionTip = false;

Vue.prototype.globalData = {
    currentUser: null
};
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
 var fappKey=localStorage.getItem('appKey')
 if(fappKey){
	 const goEasy = GoEasy.getInstance({
	 	     host: 'hangzhou.goeasy.io', //应用所在的区域地址: 【hangzhou.goeasy.io |singapore.goeasy.io】
	 	    // appkey: appKey,//'BC-729fefdf1ad7417daea8e62b9fce3f74', // common key,
	 	     appkey:fappKey,
	 		 modules: ['im'],
	  });
	  Vue.prototype.GoEasy = GoEasy;
	  Vue.prototype.goEasy = goEasy;
 }
 fetchPost('/imSys/imAppKey', {}).then(res => {
	 console.log(res.data)
	 var appKey=res.data.appKey
	 localStorage.setItem('appKey',appKey);
	 console.log(appKey)
	/* const goEasy = GoEasy.getInstance({
	     host: 'hangzhou.goeasy.io', //应用所在的区域地址: 【hangzhou.goeasy.io |singapore.goeasy.io】
	     appkey: appKey,//'BC-729fefdf1ad7417daea8e62b9fce3f74', // common key,
	     //appkey:'729fefdf1ad7417daea8e62b9fce3f74',
		 modules: ['im'],
	 });
	 Vue.prototype.GoEasy = GoEasy;
	 Vue.prototype.goEasy = goEasy; */
}) 




